import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {ElementLock} from '../../../../Models/elementLock';
import {FieldType} from '../../../../Models/enum/fieldType';
import {Utils} from '../../../../services/utils';
import {FieldDomainType} from '../../../../Models/enum/fieldDomainType';
import {DesignElementType} from '../../../../Models/enum/designElementType';
import {DropdownMultiselectComponent} from '../../../../common/dropdown-multiselect/dropdown-multiselect.component';
import {formatDate} from '@angular/common';
import {EditFieldsService} from '../../../../services/edit-fields.service';
import {FieldEditType} from '../../../../Models/enum/fieldEditType';
import {CustomValidator} from '../../../../services/custom-validator';
import {GenericModalService} from '../../../../services/generic-modal.service';
import {AdminService} from '../../../../services/admin.service';

@Component({
  selector: 'app-field-detail',
  templateUrl: './field-detail.component.html',
  styleUrls: ['./field-detail.component.css', '../../../../styles/business-process-configuration.css']
})
export class FieldDetailComponent implements OnInit {

  @Input() modalTitle: string;
  @ViewChild('childStateDropDown', {static: false}) childStateDropDown: DropdownMultiselectComponent;
  utils = Utils;

  bpId: number;
  fieldId: number;
  itemSaved: Subject<boolean> = new Subject<boolean>();
  fieldDetailForm: FormGroup;
  enumFieldType: any[];
  enumDateExhibitionFormat: any[];
  enumFieldValidator: any[];
  enumDomain: any[];
  enumMaskType: any[];
  elementLock: ElementLock = null;
  submitted = '';
  submitClick = false;
  pleaseWait = false;
  isNew = false;
  isLockedToMe = false;
  isLockedToOtherUser = false;
  lockingUserLogon: string;
  errorMessage = '';
  successMessage = '';
  bpInfo: any[];
  fieldInfo: any;

  tableRowLenght = false;
  tableRowDateFormat = false;
  tableRowValidator = false;
  tableRowDomain = false;
  tableRowStates = false;
  tableRowMask = false;
  isFixedDomain = false;
  domainMaxLength = 4000;

  availableStates = [];
  selectedStatesxistingConfig = [];
  selectedStates = [];
  objInitialState;
  editType: FieldEditType;
  forceHideDomain: boolean;
  availableFields= [];
  fieldOriginalName: string;

  public disableMultiselectState$: BehaviorSubject<any> = new BehaviorSubject<any>(true);
  get formData() { return this.fieldDetailForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private bpService: BusinessProcessService,
              private editFieldsService: EditFieldsService) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.getEnumArray();
    this.editType = this.objInitialState.editType;
    this.fieldId = this.objInitialState.fieldId;

    this.createForm();
    // this.disableMultiselectState$ = new BehaviorSubject<any>(true);
    // this.itemSaved = new Subject();

    if (this.editType === FieldEditType.single) {
      this.ngInitSingleEdit();
    } else if (this.editType === FieldEditType.multiple) {
      this.ngInitMultipleEdit();
    }

    if (this.isNew) {
      this.isLockedToMe = true;
      this.bpInfo = [];
      this.fieldInfo = [];
      // habilitar os campos correspondentes com os que estão sendo exibidos em tela
      this.enableFieldType();
    } else {
      // caso seja um novo cadastro, ao clicar em salvar, deve-se alterar o título do campo.
      this.modalTitle = 'Editar Campo';
    }

  }

  ngInitSingleEdit(){
    this.isNew = this.objInitialState.fieldId === 0;
    this.bpId = this.objInitialState.businessProcessId;
    this.forceHideDomain = false;
    if (this.bpId) {
      this.getBusinessProcessForManagementById();
    } else {
      this.pleaseWait = false;
      this.errorMessage = 'O parâmetro informado não é válido.';
    }
    this.disableMultiselectState$.next(false);
  }

  ngInitMultipleEdit(){
    this.availableStates = this.objInitialState.availableStates;
    this.availableFields = this.objInitialState.availableFields;
    this.forceHideDomain = true;
    this.disableMultiselectState$.next(false);

    this.isNew = this.objInitialState.fieldToEdit.isNew;

    //iremos tirar o tipo chave de correlação, pois não pode ser editável na tela de edição múltipla
    this.enumFieldType = this.enumFieldType.filter(item => item.key !== '6');
    if (!this.isNew){
      this.fieldInfo = this.objInitialState.fieldToEdit;
      this.fieldOriginalName = this.fieldInfo.name;
      this.loadFieldData();
      this.selectedStatesxistingConfig = this.fieldInfo['stateIdsInWhichIsEditable'];
      this.selectedStates = this.selectedStatesxistingConfig;
      this.isLockedToMe = true;
      this.isLockedToOtherUser = false;
      this.elementLock = new ElementLock();
    }
    this.fieldDetailForm.enable();
    this.pleaseWait = false;
  }

  getBusinessProcessForManagementById() {
    this.errorMessage = '';
    this.bpService.getBusinessProcessForManagementById(this.bpId)
      .subscribe(result => {
        this.bpInfo = result;
        this.availableStates = result['states'] ? result['states'].map(m => ({ id: m.stateId, label: m.name })) : [];
        if (this.fieldId !== 0) {
          this.fieldInfo = result['fields'] ? result['fields'].filter(f => f.fieldId === this.fieldId)[0] : [];
          this.selectedStatesxistingConfig = this.fieldInfo['stateIdsInWhichIsEditable'];
          this.selectedStates = this.selectedStatesxistingConfig;
          this.getCurrentElementLock();
          this.loadFieldData();
        } else {
          this.pleaseWait = false;
        }
      }, error1 => {
        let err = error1;
        this.pleaseWait = false;
        if (error1.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.errorMessage = err;
        console.error(error1);
      });
  }

  getCurrentElementLock() {
    this.errorMessage = '';
    const userLogon = localStorage.getItem('userLogon').toLowerCase();
    this.bpService.getCurrentElementLock(DesignElementType.Field, this.fieldId)
      .subscribe( element => {
        this.elementLock = element;
        if (element) {
          this.lockingUserLogon = element.user.logon;
          this.isLockedToOtherUser = this.lockingUserLogon && this.lockingUserLogon.toLowerCase() !== userLogon;
          this.isLockedToMe = this.bpId === 0 ? true : !this.isLockedToOtherUser;

          if (this.isLockedToOtherUser) {
            // this.fieldDetailForm.disable();
            this.disableForm(true);
          } else {
            // this.fieldDetailForm.enable();
            this.disableForm(false);
          }
        } else {
          // this.fieldDetailForm.disable();
          this.disableForm(true);

          this.isLockedToOtherUser = false;
          this.isLockedToMe = false;
        }
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  disableForm(element) {
    if (element) {
      this.fieldDetailForm.disable();
    } else {
      this.fieldDetailForm.enable();
    }

    // habilitar / desabilitar o dropdown de estado
    if (this.childStateDropDown) {
      // this.childStateDropDown.isDisable = element;
      this.disableMultiselectState$.next(element);
    }
  }

  getEnumArray() {
    const arrays = this.editFieldsService.getEnumArrays();

    this.enumFieldType = arrays.fieldType;
    this.enumDateExhibitionFormat = arrays.dateExibitionFormat;
    this.enumFieldValidator = arrays.fieldValidator;
    this.enumDomain = arrays.domain;
  }

  createForm() {
    this.fieldDetailForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^([a-z]|[A-Z])([a-z]|[A-Z]|\\d|_)*?$'), CustomValidator.reservedWords])],
      displayName: ['', Validators.maxLength(100)],
      description: ['', Validators.maxLength(100)],
      isRequired: false,
      isTrackable: true,
      type: 1,
      length: 0,
      dateExibitionFormat: 0,
      validator: 0,
      maskType: 0,
      domainType: 0,
      domain: [ '', Validators.maxLength(this.domainMaxLength)],
      stateIdsInWhichIsEditable: [],
      fieldId: this.fieldId,
      creationDate: [formatDate(Date.now(), 'yyyy-MM-dd', 'en_US')],
      modifiedDate: [formatDate(Date.now(), 'yyyy-MM-dd', 'en_US')]
    });
  }

  loadFieldData() {
    const fieldType = parseInt(this.fieldInfo['type'], 10);
    const domainType = parseInt(this.fieldInfo['domainType'], 10);
    const dateFormatType = parseInt(this.fieldInfo['dateExibitionFormat'], 10);
    let domainDesc = '';

    if (this.fieldInfo['domain']) {
      domainDesc = this.fieldInfo['domain'].join('\n');
    }
    this.fieldDetailForm.patchValue({
      name: this.fieldInfo['name'],
      displayName: this.fieldInfo['displayName'],
      description: this.fieldInfo['description'],
      type: fieldType,
      length: this.fieldInfo['length'],
      dateExibitionFormat: dateFormatType,
      isTrackable: this.fieldInfo['isTrackable'],
      isRequired: this.fieldInfo['isRequired'],
      validator: this.fieldInfo['validator'],
      domainType: domainType,
      domain: domainDesc,
      maskType: parseInt(this.fieldInfo['maskType'], 10),
      creationDate: this.fieldInfo['creationDate'],
      modifiedDate: this.fieldInfo['modifiedDate']
    });
    this.enableFieldType(fieldType);

    this.onSelectDomain(domainType);
    if (!this.isLockedToMe) {
      this.fieldDetailForm.disable();
    }
    this.fieldDetailForm.patchValue({ maskType: parseInt(this.fieldInfo['maskType'], 10) });
    this.pleaseWait = false;
  }

  onSave() {
    this.errorMessage = '';
    this.successMessage = '';

    const data = this.fieldDetailForm.getRawValue();
    data.stateIdsInWhichIsEditable = this.selectedStates;
    data.domain = data.domain.split('\n');
    data.type = parseInt(data.type, 10);
    data.domainType = parseInt(data.domainType, 10);
    data.dateExibitionFormat = parseInt(data.dateExibitionFormat, 10);
    data.maskType = parseInt(data.maskType, 10);
    data.validator = parseInt(data.validator, 10);
    data.name = data.name.trim();
    data.displayName = data.displayName !== null ? data.displayName.trim() : '';
    data.description = data.description !== null ? data.description.trim() : '';

    if (this.editType === FieldEditType.single) {
      this.saveEditSingle(data);
    } else if (this.editType === FieldEditType.multiple) {
      this.saveEditMultiple(data);
    }

  }

  saveEditSingle(data) {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.submitClick = true;

    this.bpService.saveField(this.bpId, data).subscribe(s => {
      this.pleaseWait = false;
      let action = 'criado';
      if (data.fieldId !== 0) {
        action = 'atualizado';
      }
      this.successMessage = `O campo foi ${action} com sucesso.`;
      this.itemSaved.next(true);
      setTimeout(() => {
        if (data.fieldId !== 0) {
          this.onUnlock();
        }
        this.submitClick = false; this.successMessage = '';
        this.objInitialState.fieldId = s;

        this.ngOnInit();
      }, 2500);
    }, error1 => {
      this.pleaseWait = false;
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.errorMessage = err;
      setTimeout(() => { this.submitClick = false; }, 2500);
    });
  }

  saveEditMultiple(data) {
    this.errorMessage = "";
    data.isNew = this.isNew;
    if (this.isNew || (data.name.toLowerCase() != this.fieldOriginalName.toLowerCase())) {
      // iremos validar se já existe um campo com o mesmo nome
      let hasField = this.availableFields.filter(f => f.name.toLowerCase() === data.name.toLowerCase()).length > 0;
      if (hasField) {
        this.errorMessage = `Já existe um campo com o nome '${data.name}'`;
        return;
      }
    }
    this.itemSaved.next(data);
    this.bsModalRef.hide();
  }

  onEdit() {
    this.errorMessage = '';
    if (!this.isLockedToOtherUser) {
      this.bpService.beginEditingElement(DesignElementType.Field, this.fieldId, this.fieldInfo['name'])
        .subscribe( () => { this.fieldDetailForm.enable(); this.getCurrentElementLock(); },
            error1 => {
              let err = error1;
              if (error1.indexOf('401') !== -1) {
                err = 'Erro: Sessão expirada.';
              }
              this.errorMessage = err;
        });
    }
  }

  onUnlock() {
    this.errorMessage = '';
    this.bpService.endEditingElement(DesignElementType.Field, this.fieldId, this.fieldInfo['name'])
      .subscribe( () => {
        this.successMessage = 'Campo desbloqueado';
        setTimeout(() => {  this.successMessage = ''; this.getBusinessProcessForManagementById(); }, 1700);
      }, error1 => {
        this.errorMessage = error1;
      } );
  }

  onFieldTypeChange(element) {
    const selectedType = parseInt(element.target.value, 10);
    this.enableFieldType(selectedType);

    this.formData.dateExibitionFormat.setValue(0);
    this.formData.length.setValue(0);
    this.formData.maskType.setValue(0);
    this.formData.validator.setValue(0);
  }

  enableFieldType(selectedType: number = 0) {
    const fieldDomain = parseInt(this.fieldDetailForm.get('domainType').value, 10);

    this.tableRowLenght = selectedType === FieldType.text;
    this.tableRowDateFormat = selectedType === FieldType.date;
    this.tableRowValidator = selectedType !== FieldType.correlationKey && selectedType !== FieldType.boolean;
    this.tableRowDomain = selectedType !== FieldType.correlationKey && selectedType !== FieldType.boolean;
    this.tableRowStates = selectedType !== FieldType.correlationKey;
    this.tableRowMask = (selectedType === FieldType.text || selectedType === FieldType.floating)
                        && fieldDomain === FieldDomainType.none;

    const result = this.editFieldsService.changeFieldType(this.fieldDetailForm, selectedType);
    this.enumMaskType = result.enumMaskType;

  }

  onSelectDomain(element) {
    const selectedItem = parseInt(element, 10);
    const selectedFieldType = parseInt(this.fieldDetailForm.get('type').value, 10);

    this.isFixedDomain = selectedItem === FieldDomainType.fixed;

    this.tableRowMask = (selectedFieldType === FieldType.text || selectedFieldType === FieldType.floating)
                      && selectedItem === FieldDomainType.none;

    if (selectedItem === FieldDomainType.fixed) {
      this.fieldDetailForm.get('domain').setValidators([Validators.required, Validators.maxLength(this.domainMaxLength)]);
    } else {
      this.fieldDetailForm.get('domain').clearValidators();
      this.formData.domain.setValue("");
      this.fieldDetailForm.get('domain').setValidators(Validators.maxLength(this.domainMaxLength));
    }
  }

  onClose() {
    if (this.editType === FieldEditType.single){
      if (this.isLockedToMe && !this.isNew) {
        this.onUnlock();
      }
      this.itemSaved.next(false);
      this.bsModalRef.hide();
    } else if (this.editType === FieldEditType.multiple){
      this.itemSaved.next(false);
      this.bsModalRef.hide();
    }

  }

  getSelectedStates(element) {
    this.selectedStates = element;
  }

  adjustSpaces(value, formControlName) {
    // const value = element.target.value;
    Utils.adjustSpaces(value, this.fieldDetailForm, formControlName);
  }
}
